import { useCallback, useEffect, useState } from 'react';

const useToolbarViewportOffset = () => {
    const [offsetTop, setOffsetTop] = useState(0);

    const updateViewportOffsetTop = useCallback(() => {
        // subtract the app header height from required offset for the toolbar
        const appHeader = document.querySelector('.AppHeader');
        const appHeaderHeight = appHeader?.getBoundingClientRect()?.height || 0;

        // don't allow a negative offset
        const actualOffset = Math.max(global.visualViewport?.offsetTop - appHeaderHeight, 0) || 0;

        setOffsetTop(actualOffset);
    }, []);

    useEffect(() => {
        if (!global.visualViewport) return;

        global.visualViewport.addEventListener('scroll', updateViewportOffsetTop);

        return () => {
            global.visualViewport.removeEventListener('scroll', updateViewportOffsetTop);
        };
    }, []);

    return offsetTop;
};

export default useToolbarViewportOffset;
